import { defineStore } from 'pinia';
import { type IStrapiImage } from '~/types/strapiImage';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';

export const useStoreCataloguePage = defineStore('cataloguePage', {
  state: () => ({
    defaultTitle: '',
    defaultMetaDescription: '',
    loadingGamesTitle: '',
    noGamesTitle: '',
    allProvidersTitle: '',
    allProvidersIcon: {} as IStrapiImage,
    allSpecialCollectionsTitle: '',
    allSpecialCollectionsIcon: {} as IStrapiImage,
    allRacesTitle: '',
    allRacesIcon: {} as IStrapiImage,
    allPromotionsTitle: '',
    allPromotionsIcon: {} as IStrapiImage,
    noGamesButWeRecommendForYou: '',
    showAllGamesTitle: '',
    latestWinnersTitle: '',
    topWinnersTitle: '',
    createdAt: null as Date | null,
    topProvidersTitle: '',
    topSpecialCollectionsTitle: '',
    showAllProvidersTitle: '',
    showAllSpecialCollectionsTitle: '',
    findProvidersTitle: '',
    findSpecialCollectionsTitle: '',
    myGamesTitle: '',
    favoriteTitle: '',
    favoriteIcon: {} as IStrapiImage,
    lastPlayedTitle: '',
    lastPlayedIcon: {} as IStrapiImage,
    locale: '',
    selected: {
      collection: '' as string,
      provider: '' as string,
    },
    hotRTPLabel: '',
    defaultCollection: 'allGames',
    exploreMoreTitle: '',
    exploreMoreIcon: {} as IStrapiImage,
    winTableGameTitle: '',
    winTableUserTitle: '',
    winTableBetTitle: '',
    winTableMultiplayerTitle: '',
    winTableProfitTitle: '',
    requestPromise: null as Promise<any> | null,
  }),

  getters: {
    selectedCollection(state): string {
      return state.selected.collection || state.defaultCollection;
    },
    selectedProvider(state): string {
      return state.selected.provider || '';
    },
  },

  actions: {
    async loadCataloguePage() {
      if (this.createdAt) {
        return;
      }

      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'allProvidersIcon',
          'allSpecialCollectionsIcon',
          'allRacesIcon',
          'allPromotionsIcon',
          'favoriteIcon',
          'lastPlayedIcon',
          'selected',
          'exploreMoreIcon',
        ]);

        this.requestPromise = strapi()
          .get('catalogue-page', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
    setCollection(collection: string) {
      this.selected.provider = '';
      this.selected.collection = collection;
    },
    setProvider(provider: string) {
      this.selected.collection = '';
      this.selected.provider = provider;
    },
  },
});
